{
  "version": 1,
  "asset_id": "cc2c16e8-0ca0-4bb8-aaed-2fe1733d490c",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/cc2c16e8-0ca0-4bb8-aaed-2fe1733d490c/prima1.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/cc2c16e8-0ca0-4bb8-aaed-2fe1733d490c/prima1.webp",
  "original_filename": "prima1.webp",
  "size": 77332,
  "content_type": "image/webp",
  "created_at": "2026-08-07T09:36:22Z"
}
